<template>
  <div class="activity-content">
    <div class="content-item" v-for="(item, index) in content" :key="index">
      <span v-if="item.type == 'text'" class="content-item-text">{{ item.value }}</span>
      <img v-if="item.type == 'img'" class="content-item-img" @click="previewImage(item.value)" :src="item.value" />
      <audio class="audio" controls v-if="item.type == 'audio' && item.url" :src="item.url"></audio>
      <article-box v-if="item.type == 'article'" :mp_icon="item.mp_icon" :mp_title="item.mp_title" :mp_url="item.mp_url"></article-box>
      <div v-if="item.type == 'file'" class="content-item-file" @click="openFile(item.file_url)">
          <div class="file-type" :style="{background:getFileType(item.file_url)=='W'?'#3691dd' : (getFileType(item.file_url)=='X'?'#1eba7d':(getFileType(item.file_url)=='P'?'#f36d44':(getFileType(item.file_url)=='rar'?'#a97c4a':'#ff686a')))}">{{getFileType(item.file_url)}}</div>
          <div class="file-name">{{item.file_name}}</div>
      </div>
      <div v-if="item.type == 'video'" class="content-item-video">
        <video-box full-width :thumb="item.url" :url="item.url_play"></video-box>
      </div>
    </div>

   
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import ArticleBox from '@/components/ArticleBox.vue';
import VideoBox from '@/components/VideoBox.vue';
export default {
  components: { ArticleBox,VideoBox },
  name: "activity-content",
  props: {
    content: {
      type: Array,
      default: [],
    },
  },
  methods: {
      getFileType(file_url) {
          let str = file_url.substring(file_url.length - 6)
          let type = ''
          if (str.indexOf('docx') != -1 || str.indexOf('DOCX') != -1 || str.indexOf('doc') != -1 || str.indexOf('DOC') != -1) type = 'W'
          if (str.indexOf('xlsx') != -1 || str.indexOf('XLSX') != -1 || str.indexOf('xls') != -1 || str.indexOf('XLS') != -1) type = 'X'
          if (str.indexOf('pptx') != -1 || str.indexOf('PPTX') != -1 || str.indexOf('ppt') != -1 || str.indexOf('PPT') != -1) type = 'P'
          if (str.indexOf('pdf') != -1 || str.indexOf('PDF') != -1) type = 'pdf'
          if (str.indexOf('rar') != -1 || str.indexOf('RAR') != -1) type = 'rar'
        return type
      },
      previewImage(url) {
        ImagePreview([url])
      },
      openFile(url) {
        window.location.href = url
      },
  }
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}

.activity-content {
  display: flex;
  flex-direction: column;
}
.content-item {
  margin-top: rem(20);
  width: 100%;
}
.content-item-text {
  font-size: rem(30);
  color: #262626;
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.content-item-img {
    width: rem(690);
}

.content-item-file {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: rem(120);
    background-color: #f2f2f7;
    padding: rem(20);
    border-radius: rem(8);
    overflow: hidden;
    box-sizing: border-box;
    cursor: pointer;
}
.file-type {
    width: rem(80);
    height: rem(80);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: rem(32);
    border-radius: rem(8);
    margin-right: rem(16);
}
.file-name {
    flex: 1;
    font-size: rem(26);
    color: #262626;
    overflow: hidden;
}
.audio {
    margin-top: rem(10);
    margin-bottom: rem(10);
    width: 100%;
}

.content-item-video {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/ActivityContent.vue